// extracted by mini-css-extract-plugin
export default {"message":"Message_message__L5SJ2","fadeIn":"Message_fadeIn__QF2Ut","success":"Message_success__7zIlm","error":"Message_error__9yfPo"};